<script>
    import { onMount } from 'svelte';
    import { db } from './stores.js';

    let sessions = [];
    let videoURL;
    let selectedSession;
    let vimeoLink;
    let status = "";

    let link = "";
    let links = [];

    onMount(async () => {
        $db.collection("breaks").orderBy("title", "desc")
            .onSnapshot((querySnapshot) => {
                sessions = [];
                querySnapshot.forEach((doc) => {
                    // console.log("showandtell",doc.data(), doc.id);
                    // showAndTellEntries.push(doc.data());
                    sessions = [...sessions, {...doc.data(), uid: doc.id}];
                    if (selectedSession && doc.id === selectedSession.uid){
                        selectedSession = {...doc.data(), uid: doc.id};
                        status = "session thumbnail updated";
                    }
                })
                console.log("sessions: ", sessions);
            });

    });
    
    function submitVideo() {
        status = "getting symbl creds";
        console.log("submitVideo videoURL: ", videoURL, selectedSession);
        const getSymblDetails = firebase.functions().httpsCallable('getSymblDetails');
        getSymblDetails({ breakId: selectedSession.uid, videoURL: selectedSession.archiveLink })
        .then((result) => {
            // Read result of the Cloud Function.
            console.log("result: ", result);
            selectedSession.symblConversationId = result.data.result.conversationId;
            selectedSession.symblJobId = result.data.result.jobId;
            status = "successfully got symbl creds";
        })
        .catch((error) => {
            console.log('error: ', error)
            status = `Error getting symbl creds: ${error}`;
        });
    }

    function generateVideoThumbnail() {
        console.log("generateVideoThumbnail!");
        status = "sending thumbnail generation request"
        const obj = document.createElement('video');
        obj.src = selectedSession.archiveLink;
        obj.ondurationchange = (event) => {
            console.log(obj.duration); 
            const generateVideoThumbnail = firebase.functions().httpsCallable('generateVideoThumbnail');
            generateVideoThumbnail({ breakId: selectedSession.uid, videoURL: selectedSession.archiveLink, duration: obj.duration })
            .then((result) => {
                // Read result of the Cloud Function.
                console.log("result: ", result);
                if (result.data.result.code === 200){
                    status = "successfully sent thumbnail generation request";
                } else {
                    status = "error trying to send thumbnail generation request";
                }
            })
            .catch((error) => {
                console.log('error: ', error)
                status = `Error sending thumbnail generation request: ${error}`;
            });

        };
    }

    function getVideoDetails() {
        status = "getting video details";
        console.log("getVideoDetails!");
        const getVideoDetails = firebase.functions().httpsCallable('getVideoDetails');
        getVideoDetails({ breakId: selectedSession.uid, symblConversationId : selectedSession.symblConversationId })
        .then((result) => {
            // Read result of the Cloud Function.
            console.log("result: ", result);
            selectedSession.summary = result.data.summary;
            selectedSession.topics = result.data.topics;
            selectedSession.transcript = result.data.transcript;
            status = "successfully got video details";
        })
        .catch((error) => {
            console.log('error: ', error)
            status = `Error getting video details: ${error}`;
        });
    }


    function uploadToVimeo() {
        status = "uploading to Vimeo";
        console.log("uploadToVimeo!");
        const uploadToVimeo = firebase.functions().httpsCallable('uploadToVimeo');
        uploadToVimeo({ breakId: selectedSession.uid, videoURL : selectedSession.archiveLink })
        .then((result) => {
            // Read result of the Cloud Function.
            console.log("result: ", result);
            selectedSession.video=[result.data.vimeoLink];
            status = "successfully uploaded to Vimeo";
        })
        .catch((error) => {
            console.log('error: ', error)
            status = `Error uploading to Vimeo: ${error}`;
        });
    }

    function updateSession() {
        console.log("updateSession: ", selectedSession);
        $db.collection("breaks").doc(selectedSession.uid).set(selectedSession,{ merge: true })
        .then(() => {
            // Read result of the Cloud Function.
            console.log("Session successfully updated");
            status = "Session successfully updated";
        })
        .catch((error) => {
            console.log('error updating session: ', error);
            status = error;
        });
    }


    function deleteSession() {
        console.log("deleteSession");
    }

    function addLink(){
        console.log("addLink: ", link);
        links = [...links,  link];
        status = "link added";
        link = "";
    }

    function saveLinks(){
        console.log("saveLinks: ", links);
        $db.collection("breaks").doc(selectedSession.uid).set({
            links
        },{ merge: true }).then(()=>{
            console.log("Succesfully saved links.");
            status = "links saved";

        }).catch((error) => {
            console.error("Error saving links: ", error);
            status = error;
        });

    }


</script>

<div id="container">
    <div id="sessions">
        sessions
        <input bind:value={videoURL}>
        <button on:click={submitVideo}>submit</button>
        {#if sessions}
            <div>
                {#each sessions as session}
                    <dwane-timer timer-deadline={session.title.split("session ")[1]} timer-orientation="horizontal"></dwane-timer>
                    <button on:click="{() => selectedSession = session}">select</button>
                    <br/><br/>
                {/each}
            </div>
        {/if}
    
    </div>
    <div id="selected">
        {#if selectedSession}
            <b>{selectedSession.uid}</b>
            <dwane-timer timer-deadline={selectedSession.title.split("session ")[1]} timer-orientation="horizontal"></dwane-timer>
            <br/> archiveLink: <input bind:value={selectedSession.archiveLink} on:input={() => videoURL = selectedSession.archiveLink}>
            <br/> thumbnail: <input bind:value={selectedSession.thumbnail}>
            <button on:click={generateVideoThumbnail}>generate from archive link</button>
            <br/>
            {#if selectedSession.video}
                video:<br/>
                {#each selectedSession.video as video}
                    {video}
                {/each}
                <br/>
            {:else}
                no videos
                <br/> vimeoLink: <input bind:value={vimeoLink} on:input={() => selectedSession.video=[vimeoLink]}>
                <button on:click={uploadToVimeo}>upload from archive link</button>
            {/if}
            <br/>
            {#if selectedSession.highlights}
                highlights:<br/>
                {#each Object.entries(selectedSession.highlights) as [key,value]}
                    {key} : <a href="{value}" target="_blank">view</a>
                {/each}

            {:else}
                no highlights
                <button>check</button>
                <button>generate from archive link</button>
            {/if}
            <br/>
            {#if selectedSession.symblConversationId && selectedSession.symblJobId}
                symbl Conversation Id:<br/>
                {selectedSession.symblConversationId}<br/>
                symbl Job Id:<br/>
                {selectedSession.symblJobId}
                <button on:click={getVideoDetails}>get video details</button>
            {:else}
                no symbl creds:
                <button on:click={submitVideo}>send to symbl with archive link</button>

            {/if}
            <br/>
            video details:
            <details>
                <summary>summary</summary>
                {#if selectedSession.summary}
                    {#each selectedSession.summary as summary}
                        <p>{summary.text}</p>
                    {/each}
                {:else}
                    no summary yet
                {/if}
            </details>
            <details>
                <summary>topics</summary>
                {#if selectedSession.topics}
                    <ul>
                        {#each selectedSession.topics as topic}
                            <li>{topic.text}</li>
                        {/each}
                    </ul>
                {:else}
                    no topics yet
                {/if}
            </details>
            <details>
                <summary>transcript</summary>
                {#if selectedSession.transcript}
                    {#each selectedSession.transcript as transcript}
                        <p>{transcript.text}</p>
                    {/each}
                {:else}
                    no transcript yet
                {/if}
            </details>
            <br/>
            {#if selectedSession.links}
                <ul>
                    {#each selectedSession.links as link}
                        <li>{link}</li>
                    {/each}
                </ul>
            {:else}
                no links yet
            {/if}
            <input bind:value={link}>
            <br/><button on:click={ addLink }>add link</button> <button on:click={ saveLinks }>save links</button>


            <br/>
            <button on:click={updateSession}>update</button><button on:click={deleteSession}>delete</button>
            {status}

        {:else}
            select a session
        {/if}
    </div>
</div>

<style>
    #container {
        display: flex;
        height: 100vh;
    }
    #selected {
        width: 50%;
        display: grid;
        /* place-content: center; */
        overflow-y: auto;
        margin: auto;
    }
    #sessions {
        overflow-y: auto;
    }
    button {
        cursor: pointer;
    }
    details {
        border: 1px solid #aaa;
        border-radius: 4px;
        padding: .5em .5em 0;
        text-align: left;
    }

    summary {
        font-weight: bold;
        margin: -.5em -.5em 0;
        padding: .5em;
    }

    details[open] {
        padding: .5em;
    }

    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: .5em;
    }

</style>